<template>
    <div>
        <el-form inline size="mini">
            <el-form-item>
                姓名：
                <el-input v-model="search_form.name" placeholder="姓名" style="width: 120px;"></el-input>
            </el-form-item>
            <el-form-item>
                手机：
                <el-input v-model="search_form.phone" placeholder="手机" style="width: 120px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" @click="query_teacher(true)">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="teacher_join_all(true)">加入</el-button>
                <el-button type="danger" @click="teacher_join_all(false)">退出</el-button>
            </el-form-item>
        </el-form>
        <el-pagination
                background
                layout="prev, pager, next, sizes, total, jumper"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="page_size"
                :total="table_totle"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"></el-pagination>
        <el-table
                :data="table_data"
                border
                size="mini"
                style="width: 100%">
            <el-table-column
                    prop="name"
                    label="姓名">
            </el-table-column>
            <el-table-column
                    prop="phone"
                    label="手机">
            </el-table-column>
            <el-table-column
                    label="操作" width="140px">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button size="mini" @click="teacher_join(scope.row,true)" type="success">加入
                        </el-button>
                        <el-button size="mini" @click="teacher_join(scope.row,false)" type="danger">退出
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import global_ from "../global";

    const admin_api = global_.admin_api;
    export default {
        name: "TeacherSelectExam",
        props: ["exam_id"],
        mounted() {
            this.query_teacher(true)
        },
        data() {
            return {
                page_num: 1,
                page_size: 10,
                join_flag: true,
                search_form: {
                    phone: "",
                    name: "",
                },
                table_totle: 0,
                table_data: []
            }
        },
        methods: {
            error_hander(response) {
                let result_code = response.data['result_code']
                let result_info = response.data['result_info']
                if (result_code === '90') {
                    this.$store.commit('set_login_state', false)
                    this.$router.replace('/login')
                } else {
                    this.$message({message: result_info, duration: 1000, type: 'error'})
                }
            },
            teacher_join(row,join_flag) {
                let request_data = {
                    service_name: 'teacher_join_exam',
                    exam_id: this.exam_id,
                    teacher_id: row.id,
                    join_flag: join_flag,
                }
                this.axios.post(admin_api, request_data).then(response => {
                    let result_code = response.data['result_code']
                    if (result_code === '00') {
                        this.$message({message: "设置成功", duration: 1000, type: 'success'})
                    } else {
                        this.error_hander(response)
                    }
                })
            },
            teacher_join_all(join_flag) {
                let request_data = {
                    service_name: 'teacher_join_exam_all',
                    exam_id: this.exam_id,
                    search_form: this.search_form,
                    join_flag: join_flag
                }
                this.axios.post(admin_api, request_data).then(response => {
                    let result_code = response.data['result_code']
                    if (result_code === '00') {
                        this.$message({message: "设置成功", duration: 1000, type: 'success'})
                    } else {
                        this.error_hander(response)
                    }
                })
            },
            handleCurrentChange(v) {
                this.page_num = v
                this.query_teacher()
            },
            handleSizeChange(v) {
                this.page_size = v
                this.query_teacher()
            },
            query_teacher(is_new = false) {
                this.table_data = []
                if (is_new) {
                    this.page_num = 1
                }
                let request_data = {
                    service_name: 'query_teacher_exam',
                    exam_id: this.exam_id,
                    page_num: this.page_num,
                    page_size: this.page_size,
                    search_form: this.search_form
                }
                this.axios.post(admin_api, request_data).then(response => {
                    let result_code = response.data['result_code']
                    let result_info = response.data['result_info']
                    if (result_code === '00') {
                        this.table_data = result_info['table_data']
                        this.table_totle = result_info['table_totle']
                    } else {
                        this.error_hander(response)
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>